// Tower mostly doesn't need parsing.
// This just parses string and number literals.

// import Constant from "./Constant";

import { TowerPrimitive } from "./Types";

export function parseLiteral(givenString: string): TowerPrimitive {
  if (givenString.trim()[0] === "[" && givenString.indexOf("]") > -1) {
    const withoutBraces = givenString
      .trim()
      .replace("[", "")
      .replace("]", "");
    return withoutBraces
      .split(",")
      .filter(parseable)
      .map(parseLiteral) as TowerPrimitive;
  }
  const givenNum = Number.parseFloat(givenString);
  if (givenString.toLowerCase().trim() === "true") {
    return true;
  } else if (givenString.toLowerCase().trim() === "false") {
    return false;
  } else if (Number.isNaN(givenNum)) {
    return givenString as TowerPrimitive;
  } else {
    return givenNum as TowerPrimitive;
  }
}

export function parseable(givenString: string) {
  return givenString.trim() !== "";
}



// WEBPACK FOOTER //
// ./src/Parsing.ts